export const ALL_CATEGORIES = 'all_categories'
export const ALL_MERCHANTS = 'all_merchants'
